import type { ComponentProps } from "react";
import { useMemo } from "react";

import { useAccommodationFilterContext } from "../filters/accommodation-filter-context";

import type { FilteredArea } from "./_utils/area-filtering";
import { AccommodationsGroup } from "./accommodations-group";
import { SiteHeader } from "./site-header";

type SiteSectionProps = Omit<
  ComponentProps<typeof AccommodationsGroup>,
  "accommodationsData"
> & {
  site: FilteredArea["sites"][number];
};

export function SiteSection({
  site,
  selected,
  ...accommodationsGroupProps
}: SiteSectionProps) {
  const { matchesAccommodationFilter } = useAccommodationFilterContext();

  const siteAccommodations = useMemo(
    () =>
      site.accommodations.filter(
        (accommodation) =>
          accommodation.id === selected?.accommodationId ||
          matchesAccommodationFilter(accommodation),
      ),
    [
      site.accommodations,
      selected?.accommodationId,
      matchesAccommodationFilter,
    ],
  );

  // showChevron: owned 物件がある場合は chevron を表示しない
  const showChevron = !siteAccommodations.some((a) => a.isOwned);

  return (
    <div>
      {siteAccommodations.length > 0 && (
        <SiteHeader
          siteData={site}
          accommodationsData={site.accommodations}
          facilitiesData={site.facilities}
          showChevron={showChevron}
        />
      )}
      <AccommodationsGroup
        accommodationsData={siteAccommodations}
        selected={selected}
        {...accommodationsGroupProps}
      />
    </div>
  );
}
